import React from 'react';
import { connect } from "react-redux";
import $ from "jquery";

import {AVAILABLE_VISUALIZERS} from "../../config";
import {hashHistory} from "react-router";
import {
  setInitialFlowFinished,
  setInitialFlowRoom, setInitialFlowRoomLayout,
  setInitialFlowStep,
  setInitialFlowType,
  setInitialFlowVisualizerNotAvailable
} from "../../actions/initialFlowFunctions";
import {INITIAL_FLOW_BUTTON_TYPES} from "../../reducers/initialFlowReducer";
import {setMaterialsTutorialFinished, setVisualizerTutorialFinished} from "../../actions/tutorialFunctions";

class InitialFlowRoom extends React.Component {

  componentDidMount() {
    this.props.setInitialFlowStep(1);
    $(".flow-room, .flow-footer").fadeIn(300);
    if (!this.props.initialFlowType) {
      this.props.setInitialFlowType(INITIAL_FLOW_BUTTON_TYPES.Quote)
    }
  }

  handleInitialRoomClick = (room) => {
    // 1) set selected room
    this.props.setInitialFlowRoom(room);
    // 2) if user clicked on unavailable visualizer -> go and set kitchen || bathroom visualizer
    const allVisualizers = Object.keys(AVAILABLE_VISUALIZERS);
    if (!allVisualizers.some(visualizer => visualizer === room)) {
      this.props.setInitialFlowVisualizerNotAvailable(true);
      const fabricatorSubscriptions = this.props.fabricatorData.fabricatorSubscriptions;
      const kitchenSubscription = fabricatorSubscriptions.find(subscription => subscription
        && subscription.service.toLowerCase() === "kitchen");
      room = kitchenSubscription ? AVAILABLE_VISUALIZERS.Kitchen : AVAILABLE_VISUALIZERS.Bathroom;
      this.exitInitialFlow();
    } else {
      if (this.props.visualizerNotAvailable) { // cases when someone returns back
        this.props.setInitialFlowVisualizerNotAvailable(false);
      }
      $(".flow-room").fadeOut(300, () => {
        hashHistory.push("/wizard/layout");
        this.props.setInitialFlowStep(2);
      });
    }
    // 3) set main config visualizer type
    document.kvConfig.visualizerType = room;
  };

  exitInitialFlow = () => {
    this.props.setInitialFlowRoomLayout(0);
    this.props.setInitialFlowStep(3);
    this.props.setInitialFlowFinished(true); // is set only once to true (to load visualizer)
    this.props.setMaterialsTutorialFinished(true);
    this.props.setVisualizerTutorialFinished(true);
    $(".flow").fadeOut(300, () => {
      hashHistory.push("materials");
    });
  };

  render() {
    const fabricatorSubscriptions = this.props.fabricatorData.fabricatorSubscriptions;
    if (!fabricatorSubscriptions.length && !this.props.initialFlowAdditionalRooms.length) {
      return (
        <div className="flow-room">
          <p>This fabricator doesn't have any subscriptions, please contact site administrator</p>
        </div>
      )
    }
    return (
      <div className="flow-room">
        {Object.keys(AVAILABLE_VISUALIZERS).map((roomKey) => {
          const subscription = fabricatorSubscriptions.find(subscription => subscription && subscription.service.toLowerCase() === roomKey.toLowerCase());
          if (!subscription) {
            return null
          }
          return (
            <button className={"flow-buttons__button flow-buttons__button--room flow-buttons__button--" + roomKey
            + (this.props.initialFlowRoom === roomKey ? " flow-buttons__button--selected" : "")}
                    key={roomKey}
                    style={{backgroundImage: `url(${subscription.thumbnail})`}}
                    onClick={() => this.handleInitialRoomClick(roomKey)}>
              <span className="flow-buttons__button-text">{roomKey}</span>
            </button>
          )
        })}
        {this.props.initialFlowType === INITIAL_FLOW_BUTTON_TYPES.Quote ? this.props.initialFlowAdditionalRooms.map((room, roomIndex) => {
          return (
            <button className={"flow-buttons__button flow-buttons__button--room flow-buttons__button--" + room.roomKey
            + (this.props.initialFlowRoom === room.roomKey ? " flow-buttons__button--selected" : "")}
                    key={roomIndex}
                    style={{backgroundImage: `url(${room.thumbnail})`}}
                    onClick={() => this.handleInitialRoomClick(room.roomKey)}
            >
              <span className="non-visualizer">Not in Visualizer</span>
              <span className="flow-buttons__button-text">{room.roomKey}</span>
            </button>
          )
        }) : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    initialFlowAdditionalRooms: store.initialFlowState.initialFlowAdditionalRooms,
    initialFlowRoom: store.initialFlowState.initialFlowRoom,
    initialFlowType: store.initialFlowState.initialFlowType,
    visualizerNotAvailable: store.initialFlowState.visualizerNotAvailable,
    fabricatorData: store.fabricatorState,
  };
};

export default connect(mapStateToProps, {
  setInitialFlowRoom,
  setInitialFlowStep,
  setInitialFlowType,
  setInitialFlowVisualizerNotAvailable,
  setInitialFlowFinished,
  setInitialFlowRoomLayout,
  setMaterialsTutorialFinished,
  setVisualizerTutorialFinished
})(InitialFlowRoom);
